import React from 'react';
import { AppRouter } from './AppRouter';
export function App() {
  return <>
      <a href="#main-content" className="skip-to-main" data-id="element-0">
        Skip to main content
      </a>
      <AppRouter data-id="element-1" />
    </>;
}